import { useSearch } from '@tanstack/react-location'
import { useFormik } from 'formik'
import { Modal } from 'MediaManager/components/Modal'
import { getVendors } from 'MediaManager/services'
import { upsertProperty } from 'MediaManager/services/property'
import { deleteApprovedVendor } from 'MediaManager/services/vendors'
import React, { useEffect, useState } from 'react'
import Button from 'shared/components/Button'
import Checkbox from 'shared/components/Checkbox'
import DataTable from 'shared/components/DataTable'
import Loader from 'shared/components/Loader'
import Select from 'shared/components/Select'
import TinyModal from 'shared/components/TinyModal'

function VendorsModal({ onClose, property, approvedVendors }) {
  const [vendors, setVendors] = useState([])
  const [selectedVendor, setSelectedVendor] = useState(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    ;(async () => {
      const { data } = await getVendors()
      setVendors(data.vendors)
      setLoading(false)
    })()
  }, [])

  const options = vendors
    .filter((v) => !approvedVendors.find((a) => a.vendor.id === v.id))
    .map((vendor) => ({
      label: vendor.full_name,
      value: vendor.id,
    }))

  const formik = useFormik({
    initialValues: {
      is_under_contract: true,
    },
    // validateOnChange: true,
    // validateOnBlur: true,
    initialTouched: false,
    // validateOnMount: true,
    onSubmit: async () => {
      await upsertProperty({
        id: property.id,
        approved_vendors: [{ vendor_id: selectedVendor, is_under_contract: formik.values.is_under_contract }],
      })
      window.location.reload()
    },
  })

  return (
    <TinyModal title="Add approved vendor" className="min-w-[500px]" closeIcon onClose={onClose}>
      {loading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <>
          {options.length === 0 && <div className="opacity-50">All the available vendors are already added</div>}
          {options.length > 0 && (
            <form onSubmit={formik.handleSubmit} className="w-full">
              <Select
                options={options}
                onChange={(value) => setSelectedVendor(value.value)}
                label="Vendor name"
              ></Select>
              <div>
                <div className="flex items-center mt-[16px]">
                  <Checkbox
                    name="is_under_contract"
                    checked={formik.values.is_under_contract}
                    onChange={() => {
                      formik.setFieldValue('is_under_contract', !formik.values.is_under_contract)
                    }}
                  />
                  <div className="ml-3 truncate">Is under contract</div>
                </div>
              </div>
              <div className="mt-[16px] flex items-center justify-end w-full">
                <Button size="small" rounded variant="secondary" onClick={onClose}>
                  Cancel
                </Button>
                <Button size="small" disabled={!selectedVendor} rounded className="ml-[16px]" type="submit">
                  Add
                </Button>
              </div>
            </form>
          )}
        </>
      )}
    </TinyModal>
  )
}

function ManagePropertyVendorsSection({ property }) {
  const [showVendorsModal, setShowVendorsModal] = useState(false)

  const table = [
    {
      label: 'ID',
      data: (d) => {
        return d.vendor.id
      },
    },
    {
      label: 'Vendor name',
      data: (d) => {
        return d.vendor.full_name
      },
    },
    {
      label: 'Is under contract',
      data: (d) => {
        return d.is_under_contract ? 'Yes' : 'No'
      },
    },
    {
      label: 'Actions',
      data: (d) => (
        <div className="flex justify-end">
          <Button
            size="small"
            variant="secondary"
            rounded
            onClick={async (e) => {
              e.stopPropagation()
              if (window.confirm(`Are you sure you want to delete ${d.vendor.full_name} approved vendor?`)) {
                await deleteApprovedVendor({
                  propertyId: property.id,
                  vendorId: d.vendor.id,
                })
                window.location.reload()
              }
            }}
            className="ml-[16px] !w-max !min-w-max"
          >
            Delete
          </Button>
        </div>
      ),
    },
  ]

  const { add_vendors_modal } = useSearch()
  useEffect(() => {
    if (add_vendors_modal) {
     
      setShowVendorsModal(true)
    }
  }, [add_vendors_modal])

  return (
    <>
      <div className="flex justify-between items-center mt-[16px]">
        <div className="text-xl">Approved Vendors</div>
        <div className="flex justify-end">
          <Button size="small" rounded variant="secondary" onClick={() => setShowVendorsModal(true)}>
            Add vendors
          </Button>
        </div>
      </div>
      <DataTable data={property.approved_vendors} structure={table} emptyLabel="No vendor members added yet" />
      {showVendorsModal && (
        <VendorsModal
          property={property}
          approvedVendors={property.approved_vendors}
          onClose={() => {
            setShowVendorsModal(false)
          }}
        />
      )}
    </>
  )
}

export default ManagePropertyVendorsSection
